/**
 * 🏭 Factory para componentes com injeção de dependência
 * Facilita a criação de componentes com suas dependências injetadas
 */

import useRecursoService from '../hooks/processo/useRecursoService'
import RecursoForm from '../Screens/screens-processo/RecursoForm'
import { useWebProvider } from '../hooks/defaults/useWebProvider'
import { useToasts } from 'react-toast-notifications'
import { useWebInterface } from '../Services/http/webInterface'
import { useLocation } from 'react-router-dom'

/**
 * Componente RecursoForm com injeção automática de dependências
 * Use este ao invés de importar RecursoForm diretamente
 */
const RecursoFormContainer = (props) => {
    const webProvider = useWebProvider()
    const initialData = useLocation().state?.initialData || null

    return <RecursoForm
        useRecursoService={useRecursoService}
        wsProvider={webProvider}
        useToastService={useToasts}
        useWebInterface={useWebInterface}
        initialData={initialData}
        {...props}
    />
}

export { RecursoFormContainer }
export default RecursoFormContainer

/**
 * Para uso em rotas:
 * element: (props) => <RecursoFormContainer {...props} />
 */